<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vClickOutside from 'v-click-outside'
import { authComputed } from '@state/helpers'
import SideNav from './side-nav'

export default {
  components: { VuePerfectScrollbar, SideNav },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    isSidebarEnable: {
      type: Boolean,
      default: false
    },
    isScroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      settings: {
        minScrollbarLength: 60,
      }
    }
  },
  computed: {
    ...authComputed,
  },
  watch: {
    'isSidebarEnable': function(val) {
      this.isSidebarEnable = val
      if (val) {
        document.body.classList.add('sidebar-enable')
        if (!this.$parent.isMobile()) {
          document.body.classList.remove('enlarged')
        }
      } else {
        document.body.classList.remove('sidebar-enable')
        if (!this.$parent.isMobile()) {
          document.body.classList.add('enlarged')
          this.$parent.isMenuScroll = false
        } else {
          document.body.classList.remove('enlarged')
        }
      }
      window.scrollTo(0, 0)
    }
  },
  mounted () {
    this.isSidebarEnable = this.$parent.sidebar
    if (this.isSidebarEnable) {
      if(this.$parent.isMobile()) {
        this.$parent.isSidebarEnable = false
        document.body.classList.remove('sidebar-enable')
      } else {
        if (this.$parent.enlarged) {
          this.$parent.isSidebarEnable = false
          document.body.classList.add('enlarged')
        } else {
          this.$parent.isSidebarEnable = true
          document.body.classList.remove('enlarged')
        }
      }
      this.$parent.isMenuScroll = true
    }
    document.body.classList.remove('enlarged')
  },
  methods: {
    clickOutside(e) {
      if (this.$parent.isMobile() && document.body.classList.contains('sidebar-enable') && !e.target.classList.contains('button-menu-mobile')) {
        this.$parent.toggleMenu()
        document.body.classList.remove('sidebar-enable')
      }
    }
  }
}
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div v-click-outside="clickOutside" class="left-side-menu" >
    <VuePerfectScrollbar
      v-if="isScroll"
      v-once
      :settings="settings"
      class="h-100"
    >
      <SideNav />
    </VuePerfectScrollbar>
    <SideNav v-else />

    <!-- Sidebar -left -->
  </div>
  <!-- Left Sidebar End -->
</template>

<style lang="scss">
.ps > .ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}
.ps > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y > .ps__scrollbar-y-rail > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:active > .ps__scrollbar-y,
.ps > .ps__scrollbar-y-rail:hover > .ps__scrollbar-y {
  width: 6px !important;
}
</style>
